module.exports = __webpack_public_path__ + "static/equipment-semi-truck-2f649a9427252b3db287fd6a820c9c63.jpg";